<template>
  <div class="process">
    <div class="title">入驻流程</div>
    <div class="process-content">
      <div v-for="(item, index) in processList" :key="index" class="flex">
        <div class="process-item">
          <div class="img-panel">
            <img :src="item.svg" width="46" height="46" class="process-img" />
          </div>
          <div class="process-name">{{ item.name }}</div>
          <div class="process-des">{{ item.des }}</div>
        </div>
        <div class="nextstep" v-if="index != 3">
          <img src="@/assets/images/home/nextstep.png" width="12" />
        </div>
      </div>
    </div>
    <!-- <div class="check-in">免费入驻</div> -->
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      processList: [
        {
          name: "注册认证",
          des: "填写表单注册成为宝尊开放平台的开发者",
          svg: require("../../../assets/images/home/authentication.png")
        },
        {
          name: "创建应用",
          des: "当您完成入驻，选择应用类型进行创建应用",
          svg: require("../../../assets/images/home/application.png")
        },
        {
          name: "开发&测试",
          des: "您需要进行开发，可在沙箱环境进行联调",
          svg: require("../../../assets/images/home/development.png")
        },
        {
          name: "发布上线",
          des: "完成开发测试后，发布至正式环境即可开始正式运营",
          svg: require("../../../assets/images/home/release.png")
        }
      ]
    };
  },
  computed: {
    ...mapGetters({})
  }
};
</script>

<style lang="less" scoped>
.process {
  color: @color-font-primary;
  align-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  .title {
    font-size: 36px;
    margin: 130px 0 38px 0;
    line-height: 36px;
  }
  .process-content {
    display: flex;
    flex-direction: row;
    padding-top: 50px;
    .nextstep {
      width: 24px;
      padding-top: 110px;
      color: @color-font-info;
      font-size: 18px;
    }
    .process-item {
      width: 300px;
      height: 300px;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0 46px;
      flex: 1;
    }
    .img-panel {
      display: flex;
      align-items: center;
      justify-content: center;
      background: @color-primary;
      border-radius: 50%;
      width: 76px;
      height: 76px;
      text-align: center;
    }

    .process-name {
      margin-top: 50px;
      margin-top: 27px;
      font-size: 24px;
    }
    .process-des {
      margin-top: 30px;
      font-size: 16px;
    }
  }
  .check-in {
    font-size: 24px;
    width: 280px;
    height: 64px;
    line-height: 64px;
    text-align: center;
    border: 2px solid @color-primary;
    border-radius: 2px;
    color: @color-primary;
    margin: 19px 0 60px 0;
    cursor: pointer;
  }
}
</style>
